import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { logError } from "@/lib/log";
import { Button } from "@/components/ui/button";
import { Link2, Copy, RefreshCw, Ban } from "lucide-react";
import { toast } from "sonner";

export default function AdminOptOutSync() {
  const [link, setLink] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/opt-outs/sync-link").then((r) => setLink(r.data)).catch((e) => logError("opt-out-sync", e)); }, []);

  const run = async (fn, ok) => {
    setBusy(true);
    try { const r = await fn(); setLink(r.data); toast.success(ok); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Something went wrong"); }
    finally { setBusy(false); }
  };
  const copy = async () => { await navigator.clipboard.writeText(link.url); toast.success("Link copied"); };

  return (
    <div className="bg-card border border-border rounded-2xl p-5" data-testid="admin-opt-out-sync">
      <p className="font-display font-semibold flex items-center gap-2 mb-1"><Link2 className="w-4 h-4 text-accent" /> Suppression sync for your outreach tool</p>
      <p className="text-xs text-muted-foreground mb-4">A secret link your outreach tool can pull on a schedule. It returns a CSV of every opted-out address (<code className="text-[11px]">email, source, opted_out_at, method</code>). Anyone with the link can read it — regenerate it if it leaks.</p>
      {link?.url ? (
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <input readOnly value={link.url} className="flex-1 min-w-0 text-xs font-mono bg-muted/50 border border-border rounded-lg px-3 py-2" data-testid="opt-out-sync-url" />
            <Button size="sm" variant="outline" onClick={copy} data-testid="opt-out-sync-copy"><Copy className="w-4 h-4 mr-1.5" /> Copy</Button>
          </div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
            <span>Created {new Date(link.created_at).toLocaleString("en-GB")}</span>
            <span className="flex-1" />
            <Button size="sm" variant="ghost" disabled={busy} onClick={() => run(() => api.post("/admin/opt-outs/sync-link"), "New link generated — update your outreach tool")} data-testid="opt-out-sync-rotate"><RefreshCw className="w-4 h-4 mr-1.5" /> Regenerate</Button>
            <Button size="sm" variant="ghost" disabled={busy} onClick={() => run(() => api.delete("/admin/opt-outs/sync-link"), "Link revoked")} data-testid="opt-out-sync-revoke"><Ban className="w-4 h-4 mr-1.5" /> Revoke</Button>
          </div>
        </div>
      ) : (
        <Button size="sm" disabled={busy} onClick={() => run(() => api.post("/admin/opt-outs/sync-link"), "Sync link created")} data-testid="opt-out-sync-create"><Link2 className="w-4 h-4 mr-1.5" /> Create sync link</Button>
      )}
    </div>
  );
}
